import { z } from 'zod'
import { authTokenSchema } from '@/core/types/AuthToken.ts'
import { responseSchema } from '@/core/types/Response.ts'

export const loginValidateCodeSchema = responseSchema(
  z.object({
    access: authTokenSchema,
    first_access: z.boolean(),
    previous_session: z.boolean(),
    previous_session_metadata: z.object({
      ip: z.string(),
      browser: z.string()
    })
  })
)

export type LoginValidateCodeResp = z.infer<typeof loginValidateCodeSchema>
